import React from 'react';
import { BrandLogo } from 'venn-ui-kit';

const Logo = () => <BrandLogo opacity={0.075} height={1100} isDark />;

export default Logo;
